import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalNotifyService } from 'src/app/core/services/modal-notify.service';
import { OperationsService } from 'src/app/core/services/operations.service';
import { CssClassMapping } from '../../../../core/configuration/css-class-mapping';
import { RoutingConfigurationUtilService } from '../../../../core/services/routing-configuration-util.service';
import { MappingTipiEntitaPratica } from "../../../configuration/mapping-tipi-entita-pratica";
import { FascicoloLight } from '../../../models/fascicolo/fascicolo-light';
import { PraticaLight } from '../../../models/pratica/pratica-light';

@Component({
    selector: 'ul [option-censimento-documenti]',
    templateUrl: 'option-censimento-documenti.component.html'
  })

  export class OptionCensimentoDocumentiComponent implements OnInit {
    @Input() fascicolo: FascicoloLight;
    @Input() pratica: PraticaLight;
    @Input() writable: boolean = false;
    @Input() canDeleteTipoDocumento: boolean = false;
    //@Input() canAddDocument: boolean = false;
    @Output() onReturnOptionCensimentoDocumenti: EventEmitter<any> = new EventEmitter<any>();


    ID_PRATICA_PARERISTICA = MappingTipiEntitaPratica.PRATICA_PARERISTICA;

    private isViewFascicoloView: boolean = true;
    private isViewPCTDeposito: boolean = true;
    private isViewPCTConsultazione: boolean = true;
    private urlPathViewFascicolo: string;
    categoriaFascicolo: string;
    templateAssociati;

    constructor(private route: ActivatedRoute,
      private router: Router,
      private routingService: RoutingConfigurationUtilService,
      private service: OperationsService, private modalNotifyService: ModalNotifyService, protected operationsService: OperationsService,) { }

    ngOnInit() {
      this.getTipoFascicolo(this.fascicolo);
    }

    getTipoFascicolo(fascicolo: FascicoloLight) {
       this.categoriaFascicolo = CssClassMapping.cssTipiCategoriaFascicolo[fascicolo.tipoFascicolo.categoria.id];
    }

    onClickOption(method: string) {
      this.onReturnOptionCensimentoDocumenti.emit({
        method
      });
    }
  }
